import { useNuxtApp } from "#imports";
export function useTrackEvent(...args) {
  if (process.client) {
    useNuxtApp().$plausible.trackEvent(...args);
  }
}
